const getNewToken = async () => {
  try {
    let req = await fetch("https://www.universal-tutorial.com/api/getaccesstoken", {
      headers: {
        "api-token":
          "0HYByzPP3BjPgPN2SEV5Ht3UnPbwPfSg03Y92Rxs8WYIUUbjHCQXuPfp-zhawI240fg",
        "user-email": "shammah@philanthrolab.com",
      },
    });
    const response = await req.json();
    localStorage.setItem("universal-country-token", response.auth_token);
    return await getCountries({ token: response.auth_token });
  } catch (error) {
    console.log(error);
    // getNewToken();
  }
};

const getCountries = async ({
  token = localStorage.getItem("universal-country-token"),
}) => {
  let countries = [];

  try {
    let req = await fetch(`https://www.universal-tutorial.com/api/countries/`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    let response = await req.json();
    if (response) {
      response.forEach((country) => {
        countries.push({
          label: country.country_name,
          value: country.country_name,
        });
      });
    }
    return countries;
  } catch (error) {
    console.log(error);
  }
};

const getStates = async ({
  country,
  token = localStorage.getItem("universal-country-token"),
}) => {
  let states = [];

  try {
    let req = await fetch(
      `https://www.universal-tutorial.com/api/states/${country}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );

    let response = await req.json();
    if (response) {
      response.forEach((state) => {
        states.push({
          label: state.state_name,
          value: state.state_name,
        });
      });
    }
    return states;
  } catch (error) {
    console.log(error);
  }
};

const getCities = async ({
  state,
  token = localStorage.getItem("universal-country-token"),
}) => {
  let cities = [];

  try {
    let req = await fetch(`https://www.universal-tutorial.com/api/cities/${state}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    let response = await req.json();
    response.forEach((city) => {
      cities.push({
        label: city.city_name,
        value: city.city_name,
      });
    });
    return cities;
  } catch (error) {
    console.log(error);
  }
};

export { getNewToken, getCountries, getStates, getCities };
